module.exports = __webpack_public_path__ + "img/logo-2.c218d454.png";